<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Seminar Classification</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="seminarClass.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="seminarClass.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Signatory 1"
              v-model="seminarClass.fullName1"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearEmployee(1)"
            >
              <template slot="append">
                <v-icon @click.stop="searchEmployee(1)">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field
              label="Position"
              :class="classPadding"
              v-model="seminarClass.desDesc1"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="Signatory 2"
              v-model="seminarClass.fullName2"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearEmployee(2)"
            >
              <template slot="append">
                <v-icon @click.stop="searchEmployee(2)">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field
              label="Position"
              :class="classPadding"
              v-model="seminarClass.desDesc2"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <!-- <pagination :key="componentKey">
        <template slot="actions" slot-scope="{item}">
          <v-btn @click.stop="edit(item)" text icon>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="deleteItem(item)" text icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>-->
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editSeminarClass.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editSeminarClass.desc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Signatory 1"
                  v-model="editSeminarClass.fullName1"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearEmployee(1)"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchEmployee(1)">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Position"
                  :class="classPadding"
                  v-model="editSeminarClass.desDesc1"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Signatory 2"
                  v-model="editSeminarClass.fullName2"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearEmployee(2)"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchEmployee(2)">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Position"
                  :class="classPadding"
                  v-model="editSeminarClass.desDesc2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Masterfile -->
      <v-dialog v-model="empDialog" width="900">
        <v-card>
          <v-card-title>
            <span class="headline">Employee Masterfile</span>
          </v-card-title>
          <v-card-text>
            <!-- <emp-masterfile-pagination :show-title="false" :show-dense="false">
              <template slot="actions" slot-scope="{item}">
                <v-btn @click.stop="selectEmp(item)" text>Select</v-btn>
              </template>
            </emp-masterfile-pagination>-->
            <signatories
              :show-title="false"
              :show-dense="false"
              :headers="signatoriesHeaders"
            >
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectEmp(item)" text>Select</v-btn>
              </template>
            </signatories>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.prevent="empDialog = false" text
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
// import EmpMasterfilePagination from "../../../../maintenance/employee-masterfile/personal-info/PaginatedList";
// import Pagination from "./Pagination";
import List from "./List";
import Signatories from "../seminar-class-sign/List";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/seminarClass";
export default {
  metaInfo: {
    title: "Seminar Classification",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List,
    // Pagination
    // EmpMasterfilePagination,
    Signatories
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    seminarClass: {},
    componentKey: 0,
    editSeminarClass: {},
    editDialog: false,
    empDialog: false,
    signSelected: 0,
    signatoriesHeaders: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "code",
        sortable: true
      },
      {
        text: "Emp Code",
        value: "signatory",
        sortable: true
      },
      {
        text: "Signatory",
        value: "fullName",
        sortable: true
      }
    ]
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.seminarClass)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editSeminarClass = rel;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.code}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.seminarClass = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editSeminarClass)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchEmployee(num) {
      this.empDialog = true;
      this.signSelected = num;
    },
    selectEmp(item) {
      if (!this.editDialog) {
        if (this.signSelected === 1) {
          this.seminarClass.fullName1 = item.fullName;
          this.seminarClass.sign1 = item.signatory;
          this.seminarClass.desCode1 = item.desDesc;
        } else {
          this.seminarClass.fullName2 = item.fullName;
          this.seminarClass.sign2 = item.signatory;
          this.seminarClass.desDesc2 = item.desDesc;
        }
      } else {
        if (this.signSelected === 1) {
          this.editSeminarClass.fullName1 = item.fullName;
          this.editSeminarClass.sign1 = item.signatory;
          this.editSeminarClass.desDesc1 = item.desDesc;
        } else {
          this.editSeminarClass.fullName2 = item.fullName;
          this.editSeminarClass.sign2 = item.signatory;
          this.editSeminarClass.desDesc2 = item.desDesc;
        }
      }
      this.empDialog = false;
    },
    clearEmployee(num) {
      if (!this.editDialog) {
        if (num === 1) {
          this.seminarClass.fullName1 = null;
          this.seminarClass.sign1 = null;
          this.seminarClass.desDesc1 = null;
        } else {
          this.seminarClass.fullName2 = null;
          this.seminarClass.sign2 = null;
          this.seminarClass.desDesc2 = null;
        }
      } else {
        if (num === 1) {
          this.editSeminarClass.fullName1 = null;
          this.editSeminarClass.sign1 = null;
          this.editSeminarClass.desDesc1 = null;
        } else {
          this.editSeminarClass.fullName2 = null;
          this.editSeminarClass.sign2 = null;
          this.editSeminarClass.desDesc2 = null;
        }
      }
    }
  },
  created() {
    this.getUserAccessRights("SemClass");
  }
};
</script>
